export const toTemplates = templates =>
  templates
    ? templates.map(t => ({
        value: t.id,
        label: t.name
      }))
    : []
